import React from 'react'
import { getPulseSchedules } from 'api'
import SchedulesTable from 'components/Scheduling/SchedulesTable'

const PulseSchedules = () => {
  return <SchedulesTable isPulse callback={getPulseSchedules} />
}

export default PulseSchedules
